/* eslint import/prefer-default-export: 0 */
import { trackEvent } from 'common/analytics';

export const trackReviewReplied = () => {
  trackEvent('review', 'update', 'reply');
};
